import { createContext, useContext } from 'react';

/**
 * @type {import('react').Context<{
 *   name: string,
 *   value: string,
 *   onChange: (value: string) => void,
 *   disabled: boolean
 * }>}
 */
const RadioContext = createContext();

const useRadio = () => {
  const context = useContext(RadioContext);
  if (!context) {
    throw new Error('useRadio must be used within a RadioProvider');
  }
  return context;
};

export { RadioContext, useRadio };
